import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type User = {
  avatar: string;
  email: string;
  first_name: string;
  last_name: string;
  full_name: string;
  phone: string;
  reward_point: number;
  product_ids: number[];
  collection_ids: string[];
  event_ids: string[];
  blog_ids: string[];
  update_time: number;
  saved_vouchers: number[];
  auth_type: string;
  total_cart_items: number;
}

export type UserState = User | null

const initialState = null as UserState

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (_state, action: PayloadAction<User>) => action.payload,
    logout: () => null,
    updateFavoriteProducts: (state, action: PayloadAction<number[]>) => {
      if (state) {
        state.product_ids = action.payload
      }
    },
    updateTotalCartItems: (state, action: PayloadAction<number>) => {
      if (state) {
        state.total_cart_items = Math.max(0, action.payload || 0)
      }
    }
  }
})

export const { setUser, logout, updateFavoriteProducts, updateTotalCartItems } = userSlice.actions
export default userSlice.reducer
